if (!customElements.get('timond-mobile-navigation')) {
  customElements.define('timond-mobile-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.querySelectorAll('details').forEach(details => {
        const sync = () => details.querySelector('summary').setAttribute('aria-expanded', String(details.open));
        sync();
        details.addEventListener('toggle', sync, { signal: this.abort.signal });
      });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

if (!customElements.get('timond-navigation-controller')) {
  customElements.define('timond-navigation-controller', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const opened = this.querySelector('details[open]');
        if (opened) { opened.open = false; opened.querySelector('summary').focus(); event.stopPropagation(); }
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.querySelectorAll('details[open]').forEach(node => { node.open = false; });
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.querySelectorAll('details[open]').forEach(node => { node.open = false; });
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
